module.exports = __webpack_public_path__ + "assets/badge-module-6.a6b1de3cb848f72682c52aa58a418234.svg";